import { ILevelGeneralListData } from './level-general-list-data';

export const levelDomainListData = {
    requestedDomainUser_guid: 'requestedDomainUser_guid',
    domain_guid: 'domain_guid',

    guid: 'guid',
    deleted: 'deleted',
    inactive: 'inactive',
} as const;

export type TLevelDomainListData = (typeof levelDomainListData)[keyof typeof levelDomainListData];

export interface ILevelDomainListData extends ILevelGeneralListData
{
    [levelDomainListData.requestedDomainUser_guid]: string;
    [levelDomainListData.domain_guid]: string;

    [levelDomainListData.guid]: string;
    [levelDomainListData.deleted]: boolean;
    [levelDomainListData.inactive]: boolean;
}

export class LevelDomainListData
    implements ILevelDomainListData, ILevelGeneralListData
{
    [levelDomainListData.requestedDomainUser_guid]!: string;
    [levelDomainListData.domain_guid]!: string;

    [levelDomainListData.guid]!: string;
    [levelDomainListData.deleted]!: boolean;
    [levelDomainListData.inactive]!: boolean;
}
